import { APIClient, PaginatedResponse } from '@frontend/api-utils';
import { SlotRendering } from '@frontend/slot/types';

export class SlotRenderingClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    public static async fetchSlotRendering(accountId: string, spotId: string, moduleId: string): Promise<PaginatedResponse<SlotRendering>> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/rendering`);
        return await this.handleResponse<PaginatedResponse<SlotRendering>>(response);
    }
}
